import * as ideaApi from '../api/idea'

import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const FETCH_IDEAS = 'FETCH_IDEAS'

export const GET_IDEA = 'GET_IDEA'
export const CREATE_IDEA = 'CREATE_IDEA'
export const UPDATE_IDEA = 'UPDATE_IDEA'
export const DELETE_IDEA = 'DELETE_IDEA'

export const SELECT_IDEA = 'SELECT_IDEA'
export const UNSELECT_IDEA = 'UNSELECT_IDEA'
export const REDIRECT_TO_IDEA = 'REDIRECT_TO_IDEA'


export const selectIdea = (ideaId) => (dispatch) => {
    dispatch({
        type: SELECT_IDEA,
        payload: ideaId,
    })
}

export const unselectIdea  = () => (dispatch) => {
    dispatch({
        type: UNSELECT_IDEA,
    })
}

export const createIdea = (ideaObj) => (dispatch) => {
    ideaApi
        .putObj(ideaObj)
        .then((data) => {
            dispatch({
                type: CREATE_IDEA,
                payload: data,
            })
            dispatch(showSuccess("Idea created!"))
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const getIdea = (_id) => (dispatch) => {
    ideaApi
        .getObj(_id)
        .then((data) => {
            dispatch({
                type: GET_IDEA,
                payload: data,
            })
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const updateIdea = (_id, ideaObj) => (dispatch) => {
    ideaApi
        .patchObj(_id, ideaObj)
        .then((data) => {
            dispatch({
                type: UPDATE_IDEA,
                payload: data,
            })
            
        })
        .then(dispatch(fetchIdeas()))
        .then(dispatch(showSuccess("Idea edited!")))
        .catch((err) => dispatch(handleApiError(err)))
}

export const deleteIdea = (_id) => (dispatch) => {
    ideaApi
        .deleteObj(_id)
        .then((data) => {
            dispatch({
                type: DELETE_IDEA,
                payload: data,
            })
            dispatch(showSuccess("Idea deleted!"))
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const fetchIdeas = (
    size,
    skip,
    sort,
    asc,
    search,
    filter_by,
    filter_value
) => (dispatch) => {
    ideaApi
        .listObj(size, skip, sort, asc, search, filter_by, filter_value)
        .then((data) => {
            dispatch({
                type: FETCH_IDEAS,
                payload: data,
            })
        })
        .catch((err) => dispatch(handleApiError(err)))
}
